package info.rezident.app.pages.profile

import info.rezident.app.data.quiz.CompletedQuiz

/**
 * Contract defining the state and events for the Profile page
 */
data class ProfileState(
    val isLoading: Boolean = false,
    val errorMessage: String? = null,
    val displayName: String = "Viitor Dr.",
    val initials: String = "💊",
    val roleText: String? = null,
    val email: String? = null,
    val memberSince: String? = null,
    val academicYear: String? = null,
    val quizzes: List<CompletedQuiz> = emptyList(),
    val completedCount: Int = 0
)

/**
 * Events that can be triggered from the Profile UI
 */
sealed interface ProfileEvent {
    data object LoadRequested : ProfileEvent
    data object RetryRequested : ProfileEvent
    data class QuizClicked(val quizId: String) : ProfileEvent
    data object StartNewQuizClicked : ProfileEvent
}
